<template>
  <div>
    <div class="owner_title">骗子库</div>
    <!-- 筛选 -->
    <div class="task_filtrate" @click="show_filter_form()">
      <i class="iconfont icon-shaixuan1"></i>
      <span>筛选</span>
    </div>

    <!-- 筛选表单 -->
    <div class="task_filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="金主QQ" prop="qq_account">
          <el-input v-model="filter_form.qq_account"></el-input>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>
    <div class="task_box">
      <el-table :data="dataShow" height="550" border width="100%">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="name"
          label="金主昵称"
          align="center"
          sortable
          :width="equipmentType == 0 ? 200 : 110"
        >
        </el-table-column>
        <el-table-column
          property="mobile"
          label="金主电话号码"
          align="center"
          sortable
          :width="equipmentType == 0 ? 200 : 130"
        >
        </el-table-column>
        <el-table-column
          property="qq_account"
          label="金主QQ"
          align="center"
          sortable
          :width="equipmentType == 0 ? 200 : 110"
        >
        </el-table-column>
        <el-table-column
          property="wx_account"
          label="金主微信"
          align="center"
          sortable
          :width="equipmentType == 0 ? 200 : 110"
        >
        </el-table-column>
        <el-table-column
          property="status"
          label="金主状态"
          align="center"
          sortable
          :width="equipmentType == 0 ? 120 : 110"
        >
          <!-- 0=新入库红色，1=合作中蓝色，2=合作过绿色 -->
          <el-tag>
            <div class="tag_circle tag_blue"></div>
            未合作
          </el-tag>
        </el-table-column>
        <el-table-column
          label="金主标签"
          align="center"
          sortable
          :width="equipmentType == 0 ? 120 : 110"
        >
          <template slot-scope="scope">
            <el-tag
              :key="item"
              v-for="item in scope.row.connectionlabel_text"
              type="info"
              >{{ item }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          property="connectionremark_text"
          label="批注"
          align="center"
          sortable
          :width="equipmentType == 0 ? 250 : 80"
        >
        </el-table-column>
        <el-table-column
          property="is_task"
          label="是否由公海转入"
          align="center"
          sortable
          :width="equipmentType == 0 ? 150 : 145"
        >
          <!-- 是否有任务:0=无任务,1=有任务  默认空 -->
          <template slot-scope="scope">
            {{ scope.row.is_high_seas == "0" ? "否" : "是" }}
          </template>
        </el-table-column>
        <el-table-column
          property="is_task"
          label="是否有任务"
          align="center"
          sortable
          :width="equipmentType == 0 ? 150 : 120"
        >
          <el-tag type="info">
            无任务
          </el-tag>
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          align="center"
          sortable
          :width="equipmentType == 0 ? 180 : 110"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { pz_connection_tabulation } from "@/utils/owner";
export default {
  data() {
    return {
      baseUrl: this.$global.commonUrl, //路径
      ownerId: "", //金主所需部门id
      cheaterList: [], //骗子列表
      dataShow: [], // 当前页要显示的数据,
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      equipmentType: 0, //设备 0-pc端 1移动端
      isFilterForm: true, // 筛选表单
      // 筛选
      filter_form: {
        qq_account: "" //写手QQ
      }
    };
  },
  created() {
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      //  手机端
      this.equipmentType = 1;
    } else {
      //  pc端
      this.equipmentType = 0;
    }
    this.getCheaterList(); //任务中心列表
  },
  methods: {
    // 获取书籍下载列表
    getCheaterList() {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId
      };
      pz_connection_tabulation(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.cheaterList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 筛选
    goSearch() {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId,
        qq_account: that.filter_form.qq_account
      };
      pz_connection_tabulation(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.cheaterList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 计算页数的方法
    calcPageData() {
      if (this.cheaterList.length > 1) {
        this.pageNum = Math.ceil(this.cheaterList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.cheaterList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      var that = this;
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}

.sea_tag .el-tag.el-tag--info {
  width: 90px;
  margin: 5px auto;
}
.remark_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  border-radius: 10px;
}
.remark_btn i {
  font-size: 12px;
}
.task_box {
  margin: 0px 15px;
}
.task_box .el-tag {
  width: 90px;
  margin: 5px auto;
}
.el-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 20px;
  border-radius: 10px;
  margin-left: 15px;
}
.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}
.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.task_filter_form {
  background: #ffffff;
  margin: 0px 16px;
  padding-top: 15px;
}

.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.myowner_btn {
  width: 110px;
  height: 20px;
  line-height: 20px;
  background: #157df8;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  border-radius: 17px;
  margin-right: 5px;
}
.highSeas_box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.sea_tag {
  text-align: center;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .task_box .el-tag {
    width: 80px;
  }
  .task_box {
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/owner/OwnerCheaterPool.vue